import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=0f03bb64&scoped=true&"
import script from "./ranking.vue?vue&type=script&lang=js&"
export * from "./ranking.vue?vue&type=script&lang=js&"
import style0 from "./ranking.vue?vue&type=style&index=0&id=0f03bb64&lang=less&scoped=true&"
import style1 from "./ranking.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f03bb64",
  null
  
)

export default component.exports